<template>
    <div>
        <label :class="{ 'checked': checked }" class="label">
            <input type="radio" :name="name" :id="filterId" :value="value" @click="radioSelected" />
            <span class="check"></span>
            <div class="text">
                <slot></slot>
            </div>
        </label>


        <div v-if="checked && childFilter">
            <div>&nbsp;</div> <div>&nbsp;</div>
            <span>{{ $t(childFilter.value)}}</span> <div>&nbsp;</div>
            <dropdown :options="childFilter.selects" :group="childFilter.group" :filtergroup="childFilter.group" :value="childFilter.value" :filter-id="childFilter.filterId" class="line-bottom green"></dropdown>
        </div>
    </div>
</template>

<script>
  import { EventBus } from '../../services/eventBus'
  import Dropdown from '../elements/Dropdown';

  export default {
    name: "info-radio",
    props: {
      filterId: String,
      name: String,
      value: String,
      currentValue: String,
      childFilter: {}
    },
    data () {
      return {
        isChecked: false
      }
    },
    computed: {
        checked: function() {
            return this.currentValue == this.value;
        }
    },
    methods: {
      radioSelected() {
        let filter = {
            filtergroup: this.name,
            value: this.value,
            filterId: this.filterId
        }
          //console.log(this.currentValue, this.value, this.checked, filter)
          EventBus.$emit('radio-button::new-value', this.value, this.name, this.filterId);
        EventBus.$emit('setFilter', filter)

      }
    },
    components: {
        'dropdown': Dropdown
    },
    mounted () {
    }
  }
</script>

<style scoped>
    .label {
        display: inline-block;
        width: 100%;
    }
.check {
    float: left !important;
}
    .text {
        padding-top: 0.9rem !important;
        padding-bottom: 0.9rem !important;
    }
    .text p {
        margin-bottom: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/elements/RadioFilter.vue